interface ICountry {
  country: string
  flag: string
  image: string
  coming?: boolean
}

const countries: ICountry[] = [
  {
    country: 'Philippines',
    flag: `${process.env.S3_BUCKET_URL}/landing/Philippines-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Philippines.png`
  },
  {
    country: 'Singapore',
    flag: `${process.env.S3_BUCKET_URL}/landing/Singapore-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Singapore.png`
  },
  {
    country: 'Indonesia',
    flag: `${process.env.S3_BUCKET_URL}/landing/Indonesia-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Indonesia.png`
  },

  {
    country: 'Hongkong',
    flag: `${process.env.S3_BUCKET_URL}/landing/Hongkong-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Hongkong.png`
  },
  {
    country: 'Macao',
    flag: `${process.env.S3_BUCKET_URL}/landing/Macao-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Macao.png`
  },
  {
    country: 'Taiwan',
    flag: `${process.env.S3_BUCKET_URL}/landing/Taiwan-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/taiwan.png`
  },
  {
    country: 'Japan',
    flag: `${process.env.S3_BUCKET_URL}/landing/Japan-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/japen.png`
  },
  {
    country: 'Malaysia',
    flag: `${process.env.S3_BUCKET_URL}/landing/Malaysia-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Malaysia.png`
    // "coming": true,
  },

  {
    country: 'Thailand',
    flag: `${process.env.S3_BUCKET_URL}/landing/Thailand-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Thailand.png`,
    coming: true
  },
  {
    country: 'Vietnam',
    flag: `${process.env.S3_BUCKET_URL}/landing/Vietnam-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Vietnam.png`,
    coming: true
  },
  {
    country: 'Australia',
    flag: `${process.env.S3_BUCKET_URL}/landing/Australia-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Australia.png`,
    coming: true
  },
  {
    country: 'Nigeria',
    flag: `${process.env.S3_BUCKET_URL}/landing/Nigeria-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Nigeria.png`,
    // coming: true
  },
  {
    country: 'South Korea',
    flag: `${process.env.S3_BUCKET_URL}/landing/SouthKorea-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/SouthKorea.png`,
    coming: true
  },
  {
    country: 'India',
    flag: `${process.env.S3_BUCKET_URL}/landing/India-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/India.png`,
    coming: true
  },
  {
    country: 'Türkiye',
    flag: `${process.env.S3_BUCKET_URL}/landing/Turkiye-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Turkiye.png`,
    coming: true
  },
  {
    country: 'Chile',
    flag: `${process.env.S3_BUCKET_URL}/landing/Chile-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Chile.png`,
    coming: true
  },
  {
    country: 'Bangladesh',
    flag: `${process.env.S3_BUCKET_URL}/landing/Bangladesh-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Bangladesh.png`,
    coming: true
  },
  {
    country: 'Europe',
    flag: `${process.env.S3_BUCKET_URL}/landing/Europe-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Europe.jpeg`,
    coming: true
  },
  {
    country: 'Brazil',
    flag: `${process.env.S3_BUCKET_URL}/landing/Brazil-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Brazil.png`,
    // coming: true
  },
  {
    country: 'USA',
    flag: `${process.env.S3_BUCKET_URL}/landing/USA-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/USA.png`,
    // coming: true
  },
  {
    country: 'Mexico',
    flag: `${process.env.S3_BUCKET_URL}/landing/Mexico-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Mexico.png`,
    coming: true
  },
  {
    country: 'Canada',
    flag: `${process.env.S3_BUCKET_URL}/landing/Canada-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Canada.png`,
    // coming: true
  },
  {
    country: 'Pakistan',
    flag: `${process.env.S3_BUCKET_URL}/landing/Pakistan-flag.png`,
    image: `${process.env.S3_BUCKET_URL}/landing/Pakistan.png`,
    coming: true
  },
  {
    country: 'United Kingdom',

    image: `${process.env.S3_BUCKET_URL}/landing/Britain.png`,
    flag: `${process.env.S3_BUCKET_URL}/landing/Britain-flag.png`,

    // isComingSoon: true
  },
  {
    country: 'Sri Lanka',
    image: `${process.env.S3_BUCKET_URL}/landing/Srilanka.png`,
    flag: `${process.env.S3_BUCKET_URL}/landing/SriLanka-flag.png`,
    // isComingSoon: true
  },
  {
    country: 'United Arab Emirates',
    image: `${process.env.S3_BUCKET_URL}/landing/UAE.png`,
    flag: `${process.env.S3_BUCKET_URL}/landing/Uae-flag.png`,
    // isComingSoon: true
  },
  {
    country: 'Spain',
    image: `${process.env.S3_BUCKET_URL}/landing/Spain.png`,
    flag: `${process.env.S3_BUCKET_URL}/landing/Spain-flag.png`,
  },
  {
    country: 'Serbia',
    image: `${process.env.S3_BUCKET_URL}/landing/Serbia.png`,
    flag: `${process.env.S3_BUCKET_URL}/landing/Serbia-flag.png`,
  },
]

export default countries
